import React, { FC } from 'react';
import { UpdateProjectPermissionError, RestoreDefaultPermissionError } from '@bechtel/types';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { RolePermissionUpdateErrorProps } from './types';
import { FooterButtonStyled } from '../styled';

const getErrorMessage = (error: RolePermissionUpdateErrorProps['updatePermissionError']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case UpdateProjectPermissionError.NOT_FOUND || RestoreDefaultPermissionError.NOT_FOUND:
      return <Trans>Permission not found.</Trans>;
    case UpdateProjectPermissionError.MISSING_REQUIRED_PERMISSION:
      return <Trans>You have no required permission to change permissions.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

const RolePermissionUpdateError: FC<RolePermissionUpdateErrorProps> = ({ updatePermissionError, close }) => {
  return (
    <Modal
      visible
      size={ModalSize.DEFAULT}
      data-testid="update-permission-error"
      style={{ width: '552px', height: '275px' }}
    >
      <ModalHeader title={t`Update/Restore Permission Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(updatePermissionError)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <FooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans>Close</Trans>
            </FooterButtonStyled>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};

export default RolePermissionUpdateError;
